import Description, { type TextFieldDescriptionProps } from "./Description";
import ErrorMessage, { type TextFieldErrorMessageProps } from "./ErrorMessage";
import Input, { type TextFieldInputProps } from "./Input";
import { InputNumber } from "./input-number";
import Label, { type TextFieldLabelProps } from "./Label";
import Password, { type TextFieldPasswordProps } from "./Password";
import Root, { type TextFieldRootProps } from "./Root";
import Textarea, { type TextFieldTextareaProps } from "./Textarea";

export const TextField = {
  Root,
  Input,
  InputNumber,
  Password,
  Textarea,
  Label,
  Description,
  ErrorMessage,
};

export type {
  TextFieldDescriptionProps,
  TextFieldErrorMessageProps,
  TextFieldInputProps,
  TextFieldLabelProps,
  TextFieldPasswordProps,
  TextFieldRootProps,
  TextFieldTextareaProps,
};
